export default "__VITE_ASSET__jVvpvqEK__"